import React from 'react';
import { Stack, Text } from '@chakra-ui/react';
import FeatureDot from './FeatureCheckbox';

const TableKey = () => (
  <Stack
    width="100%"
    direction="row"
    alignItems="center"
    justifyContent="flex-end"
    p="3"
  >
    <FeatureDot isSelected={false} />
    <Text>Not available</Text>
    <FeatureDot isSelected />
    <Text>All features</Text>
  </Stack>
);

export default TableKey;
